// extracted by mini-css-extract-plugin
export var actionButton = "_kh-0";
export var actionMenuContainer = "_kh-i";
export var bubble = "_kh-2";
export var bubbleActionMenu = "_kh-j";
export var bubbleContext = "_kh-6";
export var bubbleItems = "_kh-7";
export var customer = "_kh-3";
export var divider = "_kh-8";
export var fileList = "_kh-9";
export var hiddenComment = "_kh-o";
export var infoAbove = "_kh-a";
export var internal = "_kh-4";
export var lightActionButton = "_kh-1";
export var link = "_kh-b";
export var merchant = "_kh-5";
export var message = "_kh-c";
export var profilePicture = "_kh-e";
export var quillToolbarContainer = "_kh-f";
export var senderDate = "_kh-g";
export var senderDateCustomer = "_kh-h";
export var senderName = "_kh-d";
export var time = "_kh-k";
export var uploadedImage = "_kh-l";
export var username = "_kh-m";
export var xsmall = "_kh-n";